"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));

var _constant = require("@airasia/phoenix-components/components/AmenitiesCard/constant");

var _HotelCard = require("./HotelCard.proptypes");

var _Utils = require("./Utils");

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _loadableComponents = _interopRequireDefault(require("loadable-components"));

var _Popover = _interopRequireDefault(require("@airasia/phoenix-components/components/Popover"));

var _AmenitiesCard = _interopRequireDefault(require("@airasia/phoenix-components/components/AmenitiesCard"));

var _Rating = _interopRequireDefault(require("@airasia/phoenix-components/components/Rating"));

var _constant2 = require("../Card/constant");

var _TagIcon = _interopRequireDefault(require("./TagIcon"));

var _BogoIcon = _interopRequireDefault(require("./BogoIcon"));

var _constant3 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || (0, _typeof2.default)(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var TripAdvisor = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(
    /* webpackChunkName:"TripAdvisor" */
    "@airasia/phoenix-components/components/TripAdvisor"));
  });
});
var Label = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(
    /* webpackChunkName:"Label" */
    "@airasia/phoenix-components/components/Label"));
  });
});
var Review = (0, _loadableComponents.default)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require(
    /* webpackChunkName:"Review" */
    "@airasia/phoenix-components/components/Review"));
  });
});

var PromoTag = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoTag",
  componentId: "sc-1ew4f3l-0"
})(["width:", ";height:", ";padding-left:", ";", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '18px' : '26px';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? '18px' : '26px';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '16px' : '24px';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && 'padding-top: 12px';
});

var PromoWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoWrapper",
  componentId: "sc-1ew4f3l-1"
})(["display:flex;justify-content:center;align-items:center;margin-left:auto;background:#ededf6;width:max-content;height:28px;font-style:normal;font-weight:500;font-size:12px;line-height:150%;", ";", ";"], function (_ref5) {
  var isMobile = _ref5.isMobile;
  return !isMobile && 'padding: 4px 12px';
}, function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile && 'border-radius: 4px';
});

var QuarentinePromoWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__QuarentinePromoWrapper",
  componentId: "sc-1ew4f3l-2"
})(["display:flex;justify-content:center;align-items:center;margin-left:auto;background:#2f73d2;width:max-content;height:28px;font-style:normal;font-weight:500;font-size:12px;line-height:150%;", ";", ";"], function (_ref7) {
  var isMobile = _ref7.isMobile;
  return !isMobile && 'padding: 4px 12px';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile && 'border-radius: 4px';
});

var HotelDetails = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__HotelDetails",
  componentId: "sc-1ew4f3l-3"
})(["min-height:45%;padding-left:", ";"], function (_ref9) {
  var isMobile = _ref9.isMobile;
  return isMobile ? '16px' : '27px';
});

var HotelDetailsContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__HotelDetailsContainer",
  componentId: "sc-1ew4f3l-4"
})(["font-style:normal;line-height:130%;padding-top:13px;padding-right:", ";"], function (_ref10) {
  var isMobile = _ref10.isMobile;
  return isMobile ? '10px' : '50px';
});

var Title = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Title",
  componentId: "sc-1ew4f3l-5"
})(["font-weight:500;font-size:16px;display:inline;color:", ";"], function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.neutral;
});

var RateContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__RateContainer",
  componentId: "sc-1ew4f3l-6"
})(["padding-top:", ";"], function (_ref12) {
  var theme = _ref12.theme;
  return theme.space.mini;
});

var Stars = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Stars",
  componentId: "sc-1ew4f3l-7"
})(["display:inline;padding-left:5px;font-weight:normal;font-size:12px;color:#4c4c50;"]);

var Debug = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Debug",
  componentId: "sc-1ew4f3l-8"
})(["display:inline;padding-left:5px;font-weight:normal;font-size:12px;color:#4c4c50;"]);

var Location = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Location",
  componentId: "sc-1ew4f3l-9"
})(["font-style:normal;font-weight:normal;font-size:12px;line-height:150%;color:#75767a;padding-top:", ";padding-bottom:8px;"], function (_ref13) {
  var isMobile = _ref13.isMobile;
  return isMobile ? '2px' : '8px';
});

var LocationContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__LocationContainer",
  componentId: "sc-1ew4f3l-10"
})(["display:inline;"]);

var ReviewWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__ReviewWrapper",
  componentId: "sc-1ew4f3l-11"
})(["padding-top:", ";"], function (_ref14) {
  var isMobile = _ref14.isMobile;
  return isMobile ? '2px' : '10px';
});

var Amenities = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Amenities",
  componentId: "sc-1ew4f3l-12"
})(["height:14%;border-top:1px solid rgb(237,237,237);border-bottom:1px solid rgb(237,237,237);&:hover{background:", ";}"], function (_ref15) {
  var theme = _ref15.theme;
  return "".concat(theme.backgroundColor.primary);
});

var Miscellaneous = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Miscellaneous",
  componentId: "sc-1ew4f3l-13"
})(["display:flex;font-style:normal;font-weight:500;font-size:12px;padding:11px 25px;"]);

var MiscellaneousCarousal = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__MiscellaneousCarousal",
  componentId: "sc-1ew4f3l-14"
})(["display:flex;font-style:normal;font-weight:500;font-size:10px;padding-top:0px;"]);

var Cancellation = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__Cancellation",
  componentId: "sc-1ew4f3l-15"
})(["display:flex;align-items:center;color:#067e41;padding-right:8px;"]);

var BreakLine = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__BreakLine",
  componentId: "sc-1ew4f3l-16"
})(["max-width:30px;word-wrap:break-word;"]);

var PayLater = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PayLater",
  componentId: "sc-1ew4f3l-17"
})(["display:flex;align-items:center;color:rgba(6,126,65,0.2);"]);

var LowInventoryAlert = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__LowInventoryAlert",
  componentId: "sc-1ew4f3l-18"
})(["display:flex;align-items:center;", ";&:first-child{", ";}"], function (props) {
  return props.freeCancellationText || props.payLaterText || props.payNowText ? 'margin-left: 6px' : 'margin-left: 0px';
}, function (props) {
  return props.freeCancellationText || props.payLaterText || props.payNowText ? 'padding-right: 2px' : 'padding-right: 0px';
});

var NoHotelAvailableAlert = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__NoHotelAvailableAlert",
  componentId: "sc-1ew4f3l-19"
})(["display:flex;background-color:#fbebe9;border-radius:4px;", ";", ";"], function (props) {
  return props.isMobile ? 'padding: 4px 4px' : 'padding: 4px 10px';
}, function (props) {
  return props.isMobile ? 'margin: 16px' : 'margin: 30px 27px 22px 24px';
});

var FomoContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__FomoContainer",
  componentId: "sc-1ew4f3l-20"
})(["display:'flex';font-style:normal;font-weight:500;font-size:12px;"]);

var FomoWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__FomoWrapper",
  componentId: "sc-1ew4f3l-21"
})(["display:flex;align-items:center;padding-left:25px;", ";padding-bottom:11px;"], function (props) {
  return props.addExtraPadding ? 'padding-top: 11px' : 'padding-top: 0px';
});

var AmenityWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__AmenityWrapper",
  componentId: "sc-1ew4f3l-22"
})(["padding-left:27px;padding-top:10px;padding-bottom:10px;display:flex;"]);

var AmenityContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__AmenityContainer",
  componentId: "sc-1ew4f3l-23"
})(["color:#75767a;display:flex;align-items:center;padding-right:14px;font-style:normal;font-weight:normal;font-size:12px;line-height:16px;"]);

var PromoContainer = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoContainer",
  componentId: "sc-1ew4f3l-24"
})(["display:flex;align-items:center;margin-bottom:12px;"]);

var PromoWrapperWeb = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoWrapperWeb",
  componentId: "sc-1ew4f3l-25"
})(["height:14%;border-bottom:1px solid rgb(237,237,237);&:hover{background:", ";}"], function (_ref16) {
  var theme = _ref16.theme;
  return "".concat(theme.backgroundColor.primary);
});

var BogoPromowrapperweb = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__BogoPromowrapperweb",
  componentId: "sc-1ew4f3l-26"
})(["height:14%;padding-top:8px;&:hover{background:", ";}"], function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.backgroundColor.primary);
});

var PromoWrapperMWeb = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoWrapperMWeb",
  componentId: "sc-1ew4f3l-27"
})(["height:10%;padding-left:16px;display:flex;align-items:center;margin-top:5px;"]);

var PromoHoverText = _styledComponents.default.text.withConfig({
  displayName: "HotelInfo__PromoHoverText",
  componentId: "sc-1ew4f3l-28"
})(["font-size:", ";font-weight:", ";color:#75767a;"], function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontSize.small;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.small;
});

var PromoTagWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__PromoTagWrapper",
  componentId: "sc-1ew4f3l-29"
})(["display:flex;align-items:center;width:max-content;"]);

var FlyerDiscountWrapper = _styledComponents.default.div.withConfig({
  displayName: "HotelInfo__FlyerDiscountWrapper",
  componentId: "sc-1ew4f3l-30"
})(["display:flex;justify-content:center;align-items:center;margin-left:", ";background:", ";width:max-content;height:28px;font-style:normal;font-weight:500;font-size:12px;line-height:150%;", ";"], function (_ref20) {
  var promoTag = _ref20.promoTag;
  return promoTag ? '10px' : '0px';
}, function (_ref21) {
  var theme = _ref21.theme;
  return theme.colors.primaryLight;
}, function (_ref22) {
  var isMobile = _ref22.isMobile;
  return isMobile ? 'border-radius: 4px' : 'padding: 4px 12px';
});

var Amenity = function Amenity(_ref23) {
  var amenities = _ref23.amenities;
  var showable = amenities.slice(0, 3);
  return /*#__PURE__*/_react.default.createElement(AmenityWrapper, null, showable.map(function (amenity) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(AmenityContainer, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: _constant.ICON_MAPPER[amenity.id],
      color: "greyDark"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "greyDark"
    }, " ", amenity.name, " ")));
  }));
};

var HotelInfo = function HotelInfo(_ref24) {
  var promoTag = _ref24.promoTag,
      freeCancellationText = _ref24.freeCancellationText,
      promoTitle = _ref24.promoTitle,
      payLaterText = _ref24.payLaterText,
      payAtHotelText = _ref24.payAtHotelText,
      amenities = _ref24.amenities,
      starRating = _ref24.starRating,
      debug = _ref24.debug,
      hotelName = _ref24.hotelName,
      location = _ref24.location,
      distance = _ref24.distance,
      reviews = _ref24.reviews,
      isCarouselCard = _ref24.isCarouselCard,
      carouselFreeCancellation = _ref24.carouselFreeCancellation,
      tripAdvisorReviews = _ref24.tripAdvisorReviews,
      setAmenityFocused = _ref24.setAmenityFocused,
      title = _ref24.title,
      theme = _ref24.theme,
      isMobile = _ref24.isMobile,
      highlight = _ref24.highlight,
      templateType = _ref24.templateType,
      reviewTranslation = _ref24.reviewTranslation,
      lowInventoryAlert = _ref24.lowInventoryAlert,
      discountType = _ref24.discountType,
      isHotelNotAvailable = _ref24.isHotelNotAvailable,
      noHotelsAvailableWarning = _ref24.noHotelsAvailableWarning,
      isPromoEnabled = _ref24.isPromoEnabled,
      promoText = _ref24.promoText,
      promoHoverText = _ref24.promoHoverText,
      fomoMessage = _ref24.fomoMessage,
      bogoMessage = _ref24.bogoMessage,
      isBogoPromoEnabled = _ref24.isBogoPromoEnabled,
      payNowText = _ref24.payNowText,
      move = _ref24.move,
      isCrossSell = _ref24.isCrossSell,
      flyerDiscountLabel = _ref24.flyerDiscountLabel,
      isHotel = _ref24.isHotel;

  var getPopoverTop = function getPopoverTop() {
    var top = 120;
    top += 33 * (Math.ceil(amenities.length / 4) - 1);
    return "-".concat(top, "px");
  };

  var mouseEnterHandler = function mouseEnterHandler() {
    setAmenityFocused(true);
  };

  var QuarentineDiscountType = 'quarantine_deal';

  var mouseLeaveHandler = function mouseLeaveHandler() {
    setAmenityFocused(false);
  };

  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _ref25 = starRating || {},
      stars = _ref25.stars,
      text = _ref25.text;

  var _ref26 = debug || {},
      supplierId = _ref26.supplier_id,
      aaid = _ref26.aaid;

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !highlight && (promoTag || flyerDiscountLabel) && /*#__PURE__*/_react.default.createElement(PromoTag, {
      isMobile: isMobile
    }, promoTitle && isMobile ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _Utils.isNotEmpty)(discountType) && discountType === QuarentineDiscountType ? /*#__PURE__*/_react.default.createElement(QuarentinePromoWrapper, {
      isMobile: isMobile,
      style: {
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(Label, {
      labelColor: "blue",
      textColor: "default",
      theme: theme
    }, promoTitle)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(PromoWrapper, {
      isMobile: isMobile,
      style: {
        flexDirection: 'row'
      }
    }, /*#__PURE__*/_react.default.createElement(Label, {
      labelColor: "secondaryLight",
      textColor: "secondaryDark",
      theme: theme
    }, promoTitle)))) : /*#__PURE__*/_react.default.createElement(PromoTagWrapper, null, promoTag && /*#__PURE__*/_react.default.createElement(PromoWrapper, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(Label, {
      labelColor: "secondaryLight",
      textColor: "secondaryDark",
      theme: theme
    }, promoTag)), flyerDiscountLabel && /*#__PURE__*/_react.default.createElement(FlyerDiscountWrapper, {
      isMobile: isMobile,
      promoTag: promoTag
    }, /*#__PURE__*/_react.default.createElement(Label, {
      labelColor: "primaryLight",
      textColor: "primaryDark",
      theme: theme
    }, flyerDiscountLabel)))), /*#__PURE__*/_react.default.createElement(HotelDetails, {
      isMobile: isMobile
    }, !isCrossSell ? /*#__PURE__*/_react.default.createElement(HotelDetailsContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(Title, null, hotelName), stars && text && /*#__PURE__*/_react.default.createElement(Stars, null, "(".concat(stars, " ").concat(text, ")")), supplierId && aaid && /*#__PURE__*/_react.default.createElement(Debug, null, "(".concat(supplierId, "-").concat(aaid, ")"))) : /*#__PURE__*/_react.default.createElement(HotelDetailsContainer, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(Title, null, hotelName, /*#__PURE__*/_react.default.createElement(RateContainer, null, stars && /*#__PURE__*/_react.default.createElement(_Rating.default, {
      accessible: false,
      maxRate: 5,
      rate: parseInt(stars, 10),
      starColor: _constant3.TOKENS.STARS.COLOR,
      starSize: _constant3.TOKENS.STARS.STAR_SIZE,
      theme: theme,
      type: _constant3.TOKENS.STARS.TYPE,
      isSpanContainer: true
    }), ' '), ' '), supplierId && aaid && /*#__PURE__*/_react.default.createElement(Debug, null, "(".concat(supplierId, "-").concat(aaid, ")"))), templateType !== _constant2.TEMPLATE_TYPE.HOTEL_CARD && /*#__PURE__*/_react.default.createElement(Location, {
      isMobile: isMobile
    }, location && /*#__PURE__*/_react.default.createElement(LocationContainer, {
      borderRight: distance
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "LocationOnIcon",
      color: "greyDark"
    }), /*#__PURE__*/_react.default.createElement(Label, null, location, distance ? " | ".concat(distance) : ''))), tripAdvisorReviews && /*#__PURE__*/_react.default.createElement(TripAdvisor, (0, _extends2.default)({}, tripAdvisorReviews, {
      isMobileView: isMobile
    })), !tripAdvisorReviews && reviews && /*#__PURE__*/_react.default.createElement(ReviewWrapper, null, /*#__PURE__*/_react.default.createElement(Review, {
      accessible: true,
      backgroundColor: "secondary",
      data: reviews,
      fontSize: move ? 'bold' : 'XSmall',
      lineHeight: move ? 'semiLarge' : 'small',
      messageColor: move ? 'darkGreen' : 'secondary',
      oneline: !isMobile,
      reviewCountColor: "greyDark",
      scoreCardLeftColor: "default",
      scoreCardRightColor: move ? 'default' : 'greyLight',
      theme: themeContext,
      textType: templateType === _constant2.TEMPLATE_TYPE.HOTEL_CARD ? 'small' : 'sub',
      reviewTranslation: reviewTranslation,
      move: move
    })), isBogoPromoEnabled && bogoMessage && !isMobile && /*#__PURE__*/_react.default.createElement(BogoPromowrapperweb, null, /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(_BogoIcon.default, null), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "blue"
    }, bogoMessage))), isCarouselCard && /*#__PURE__*/_react.default.createElement(MiscellaneousCarousal, null, carouselFreeCancellation && /*#__PURE__*/_react.default.createElement(BreakLine, null, /*#__PURE__*/_react.default.createElement(Cancellation, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "tertiary",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "tertiaryDark"
    }, carouselFreeCancellation))))), !isMobile && amenities && amenities.length !== 0 && !isHotelNotAvailable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Amenities, {
      onMouseEnter: mouseEnterHandler,
      onMouseLeave: mouseLeaveHandler
    }, amenities.length > 3 ? /*#__PURE__*/_react.default.createElement(_Popover.default, {
      left: "-190px",
      zIndex: 1,
      top: getPopoverTop(),
      marginLeft: "auto",
      padding: "24px",
      width: 700,
      position: "top",
      content: /*#__PURE__*/_react.default.createElement(_AmenitiesCard.default, {
        amenities: amenities,
        title: title
      })
    }, /*#__PURE__*/_react.default.createElement(Amenity, {
      amenities: amenities
    })) : /*#__PURE__*/_react.default.createElement(Amenity, {
      amenities: amenities
    }))), isPromoEnabled && !isBogoPromoEnabled && (!isMobile ? /*#__PURE__*/_react.default.createElement(PromoWrapperWeb, null, /*#__PURE__*/_react.default.createElement(AmenityWrapper, null, promoHoverText ? /*#__PURE__*/_react.default.createElement(_Popover.default, {
      left: "-40px",
      zIndex: 1,
      top: "-80px",
      marginLeft: "auto",
      padding: "20px",
      width: 300,
      position: "top",
      customProperties: {
        style: {
          height: '100%'
        }
      },
      borderRadius: 4,
      content: /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(PromoHoverText, null, promoHoverText))
    }, /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(_TagIcon.default, null), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "blue"
    }, promoText))) : /*#__PURE__*/_react.default.createElement(PromoContainer, null, /*#__PURE__*/_react.default.createElement(_TagIcon.default, null), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "blue"
    }, promoText)))) : /*#__PURE__*/_react.default.createElement(PromoWrapperMWeb, null, /*#__PURE__*/_react.default.createElement(_TagIcon.default, null), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "blue"
    }, promoText))), !isMobile && !isHotelNotAvailable && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (freeCancellationText || payLaterText || payAtHotelText || payNowText || lowInventoryAlert) && /*#__PURE__*/_react.default.createElement(Miscellaneous, null, freeCancellationText && /*#__PURE__*/_react.default.createElement(Cancellation, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "CheckIcon",
      color: "tertiary",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "tertiaryDark"
    }, freeCancellationText)), payLaterText && /*#__PURE__*/_react.default.createElement(PayLater, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "FiberManualRecordIcon",
      color: "tertiaryLight",
      fontsize: "semiXSmall",
      padding: "0px 6px"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "tertiaryDark"
    }, " ", payLaterText, " ")), payAtHotelText && /*#__PURE__*/_react.default.createElement(PayLater, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "FiberManualRecordIcon",
      color: "tertiaryLight",
      fontsize: "semiXSmall",
      padding: "0px 6px"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "tertiaryDark"
    }, " ", payAtHotelText, " ")), payNowText && /*#__PURE__*/_react.default.createElement(PayLater, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "FiberManualRecordIcon",
      color: "tertiaryLight",
      fontsize: "semiXSmall",
      padding: "0px 6px"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "tertiaryDark"
    }, " ", payNowText, " ")), lowInventoryAlert && /*#__PURE__*/_react.default.createElement(LowInventoryAlert, {
      payNowText: payNowText,
      freeCancellationText: freeCancellationText,
      payLaterText: payLaterText
    }, ((0, _Utils.isNotEmpty)(freeCancellationText) || (0, _Utils.isNotEmpty)(payLaterText)) && /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "FiberManualRecordIcon",
      color: "primaryLight",
      fontsize: "semiXSmall",
      padding: "0px 6px"
    }), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "ErrorOutlineIcon",
      color: "primary",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "primary"
    }, " ", lowInventoryAlert, " "))), fomoMessage && /*#__PURE__*/_react.default.createElement(FomoContainer, null, /*#__PURE__*/_react.default.createElement(FomoWrapper, {
      addExtraPadding: !isHotel && !(freeCancellationText || payLaterText || payAtHotelText || payNowText || lowInventoryAlert)
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "FlashOnRoundedIcon",
      color: "orangeNeutral",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "orangeNeutral"
    }, fomoMessage)))), isHotelNotAvailable && /*#__PURE__*/_react.default.createElement(NoHotelAvailableAlert, {
      isMobile: isMobile
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "ErrorOutlineIcon",
      color: "primary",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(Label, {
      textColor: "primary",
      theme: theme
    }, noHotelsAvailableWarning)));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

Amenity.propTypes = _HotelCard.AmenityPropTypes;
Amenity.defaultProps = _HotelCard.AmenityDefaultProps;
HotelInfo.propTypes = _HotelCard.HotelInfoPropTypes;
HotelInfo.defaultProps = _HotelCard.HotelInfoDefaultProps;
var _default = HotelInfo;
exports.default = _default;